import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getAreas } from 'actions/regions/areas';
import { getAllPorts } from 'actions/regions/ports';

import FilterAreas from './FilterAreas/Component';
import { AreaEditor } from './AreaEditor';

const RegionsDashboards = (props) => {
    const {
        ports, areas, router, getAllPorts, getAreas, 
    } = props;
    const [areaId, setAreaId] = useState(null);
    // const [searchArea, setSearchArea] = useState(null);

    // Fetch data on component mount (replaces componentWillMount)
    useEffect(() => {
        getAllPorts();
        getAreas();
    }, [getAllPorts, getAreas]);

    const onSelectAreaById = (id) => {
        setAreaId(id);
    };

    const onSelectArea = (selectedArea) => {
        selectedArea.isNew = false;
        onSelectAreaById(selectedArea._id);
    };

    const selectParentArea = (searchAreaId) => {
        onSelectAreaById(searchAreaId);
    };

    return (
        <div id='regions-dashboard' className='page'>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-xs-2'>
                        <FilterAreas
                            router={router}
                            areas={areas}
                            selectedArea={areaId}
                            onSelectArea={onSelectArea}
                            // searchArea={searchArea}
                        />
                    </div>

                    <div className="col-xs-10">
                        <AreaEditor
                            ports={ports}
                            areas={areas}
                            areaId={areaId}
                            selectArea={onSelectAreaById}
                            router={router}
                            selectParentArea={selectParentArea}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default connect(
    ({ ports, areas, user }) => ({
        ports,
        areas,
        isLogged: user.isLogged,
    }),
    dispatch => bindActionCreators(
        {
            getAreas,
            getAllPorts,
        },
        dispatch,
    ),
)(RegionsDashboards);



// WEBPACK FOOTER //
// ./app/components/Regions/Dashboard/Page.jsx